import React from "react";
import ReactDOM from "react-dom/client";
import "@assets/styles/index.css";
import App from "./App.jsx";
import { FilterProvider } from "@context/filterContext.jsx";
import { RentFilterProvider } from "@context/rentFilter.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FilterProvider>
      <RentFilterProvider>
        <App />
      </RentFilterProvider>
    </FilterProvider>
  </React.StrictMode>
);
